import { Box, Button, Stack, Typography } from '@mui/material';

import backgroundBrandLinesUrl from 'src/assets/images/error-icons/background-brand-lines.svg?url';
import ErrorIcon from 'src/assets/images/error-icons/diamond-exclamation.svg';
import { ZendeskUrl } from 'src/constants/ExternalUrls';

function ErrorPage() {
    return (
        <Box
            sx={{
                boxSizing: 'border-box',
                pt: 10,
                height: '100dvh',
                backgroundPosition: 'center bottom',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% auto',
                backgroundImage: `url("${backgroundBrandLinesUrl}")`,
            }}
        >
            <Stack sx={{ p: 2.5, gap: 2.5 }}>
                <Stack
                    sx={{
                        gap: 1,
                        alignItems: 'start',
                    }}
                >
                    <img src={ErrorIcon} alt="" />
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >
                        Something went wrong
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'grey.900',
                        }}
                    >
                        Reloading Sage will take care of it most of the time. If you keep ending up
                        here, you can reach out to us from our help center.
                    </Typography>
                </Stack>

                <Button variant="contained" disableElevation fullWidth href={`/?t=${Date.now()}`}>
                    Reload
                </Button>
                <Button
                    variant="outlined"
                    disableElevation
                    fullWidth
                    href={ZendeskUrl}
                    target="_blank"
                >
                    Get Help
                </Button>
            </Stack>
        </Box>
    );
}

export default ErrorPage;
